var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 88,
    viewBox: "0 0 64 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H46.1855C46.5771 0.5 46.9532 0.653173 47.2334 0.926789L63.048 16.3692C63.337 16.6515 63.5 17.0384 63.5 17.4424V86C63.5 86.8284 62.8284 87.5 62 87.5H2C1.17157 87.5 0.5 86.8284 0.5 86V2Z",
    fill: "#FFF6EE",
    stroke: "#FEE5CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 17V0H48.1716C48.702 0 49.2107 0.210714 49.5858 0.585786L63.4142 14.4142C63.7893 14.7893 64 15.298 64 15.8284V18H47C46.4477 18 46 17.5523 46 17Z",
    fill: "#FECC9A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 49.1818V39H23.017C23.7893 39 24.4472 39.1475 24.9908 39.4425C25.5343 39.7341 25.9486 40.1402 26.2337 40.6605C26.522 41.1776 26.6662 41.7741 26.6662 42.4503C26.6662 43.1264 26.5204 43.723 26.2287 44.2401C25.937 44.7571 25.5144 45.1598 24.9609 45.4482C24.4107 45.7365 23.7446 45.8807 22.9624 45.8807H20.402V44.1555H22.6143C23.0286 44.1555 23.37 44.0843 23.6385 43.9418C23.9103 43.7959 24.1125 43.5954 24.245 43.3402C24.3809 43.0817 24.4489 42.785 24.4489 42.4503C24.4489 42.1122 24.3809 41.8172 24.245 41.5653C24.1125 41.3101 23.9103 41.1129 23.6385 40.9737C23.3667 40.8312 23.022 40.7599 22.6044 40.7599H21.1527V49.1818H19Z",
    fill: "#FB7F03"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6738 49.1818H28.0645V39H31.7037C32.7278 39 33.6094 39.2038 34.3485 39.6115C35.0877 40.0159 35.6561 40.5975 36.0538 41.3565C36.4548 42.1155 36.6554 43.0237 36.6554 44.081C36.6554 45.1416 36.4548 46.053 36.0538 46.8153C35.6561 47.5777 35.0843 48.1626 34.3386 48.5703C33.5962 48.978 32.7079 49.1818 31.6738 49.1818ZM30.2172 47.3374H31.5843C32.2207 47.3374 32.756 47.2247 33.1902 46.9993C33.6277 46.7706 33.9558 46.4176 34.1745 45.9403C34.3966 45.4598 34.5076 44.84 34.5076 44.081C34.5076 43.3286 34.3966 42.7138 34.1745 42.2365C33.9558 41.7592 33.6293 41.4079 33.1951 41.1825C32.761 40.9571 32.2257 40.8445 31.5893 40.8445H30.2172V47.3374Z",
    fill: "#FB7F03"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 49.1818V39H44.9915V40.7749H40.4027V43.201H44.544V44.9759H40.4027V49.1818H38.25Z",
    fill: "#FB7F03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.a13dfb21482ea59df814a5a574ca7516.svg";
export { ForwardRef as ReactComponent };